//import { clubList } from "./../../../../nls-api/src/apiConsts";
import { FACompsBySeasonType } from "./../../types/blog/blogContentTypes";
import {
  FACompCurrentRoundsType,
  SponsorType,
  FACompType,
  FACompDetailsType,
  FACompsResultBySeasonType,
  FACompReferenceType,
} from "../../types/blog/blogContentTypes";

export const Sponsors: Array<SponsorType> = [
  {
    sponsorName: "Isuzu",
    sponsorUrl: "https://www.isuzu.co.uk/",
    sponsorIconUrl: "",
  },
  {
    sponsorName: "BuildBase",
    sponsorUrl: "https://www.buildbase.co.uk/",
    sponsorIconUrl: "",
  },
  {
    sponsorName: "Emirates",
    sponsorUrl: "https://www.emirates.com/",
    sponsorIconUrl: "",
  },
];

export const FAComps: Array<FACompReferenceType> = [
  {
    comp: FACompType.FACup,
    name: "FA Cup",
    sponsorName: "Emirates",
    categories: ["non league news", "fa comps", "fa cup"],
  },
  {
    comp: FACompType.FAVase,
    name: "FA Vase",
    sponsorName: "Isuzu",
    categories: ["non league news", "fa comps", "fa vase"],
  },
  {
    comp: FACompType.FATrophy,
    name: "FA Trophy",
    sponsorName: "Isuzu",
    categories: ["non league news", "fa comps", "fa trophy"],
  },
];

export const FACompCurrentRounds: Array<FACompCurrentRoundsType> = [
  {
    comp: FACompType.FACup,
    roundNames: [
      "Extra Preliminary Round",
      "Preliminary Round",
      "First Round Qualifying",
      "Second Round Qualifying",
      "Third Round Qualifying",
      "Fourth Round Qualifying",
      "First Round Proper",
      "Second Round Proper",
      "Third Round Proper",
      "Fourth Round Proper",
      "Fifth Round Proper",
      "Quarter Final",
      "Semi Final",
      "Final",
    ],
  },
  {
    comp: FACompType.FATrophy,
    roundNames: [
      "First Round Qualifying",
      "Second Round Qualifying",
      "Third Round Qualifying",
      "First Round Proper",
      "Second Round Proper",
      "Third Round Proper",
      "Fourth Round Proper",
      "Fifth Round Proper",
      "Quarter Final",
      "Semi Final",
      "Final",
    ],
  },
  {
    comp: FACompType.FAVase,
    roundNames: [
      "First Round Qualifying",
      "Second Round Qualifying",
      "First Round Proper",
      "Second Round Proper",
      "Third Round Proper",
      "Fourth Round Proper",
      "Fifth Round Proper",
      "Quarter Final",
      "Semi Final",
      "Final",
    ],
  },
];

export const FACompsResultBySeasonDate: Array<FACompsResultBySeasonType> = [
  {
    season: "2021-22",
    compDetailsList: [
      {
        season: "2021-22",
        comp: FACompType.FATrophy,
        clubs: ["bromley", "wrexham"],
        winningClub: "",
        losingClub: "",
        aet: false,
        pens: false,
        score: "",
        winningClubDetail: null,
        losingClubDetail: null,
      },
      {
        season: "2021-22",
        comp: FACompType.FAVase,
        clubs: ["littlehampton-town-fc", "newport-pagnell-town-fc"],
        aet: false,
        pens: false,
        score: "",
        winningClub: "",
        losingClub: "",
        winningClubDetail: null,
        losingClubDetail: null,
      },
    ],
  },
];

export const FACompsBySeasonDate: Array<FACompsBySeasonType> = [
  {
    season: "2021-22",
    compDetailsList: [
      {
        season: "2021-22",
        comp: FACompType.FATrophy,
        roundName: "Fourth Round Proper",
        roundDate: "2022-01-15",
        noOfTies: 16,
        winnerPrizeMoney: 5250,
        loserPrizeMoney: 1500,
        matchList: null,
        otherText: "",
      },
      {
        season: "2021-22",
        comp: FACompType.FATrophy,
        roundName: "Fifth Round Proper",
        roundDate: "2022-02-12",
        noOfTies: 8,
        winnerPrizeMoney: 6000,
        loserPrizeMoney: 1750,
        matchList: null,
        otherText: "",
      },
      {
        season: "2021-22",
        comp: FACompType.FATrophy,
        roundName: "Quarter Final",
        roundDate: "2022-03-12",
        noOfTies: 4,
        winnerPrizeMoney: 7500,
        loserPrizeMoney: 2000,
        matchList: null,
        otherText: "",
      },
      {
        season: "2021-22",
        comp: FACompType.FATrophy,
        roundName: "Semi Final",
        roundDate: "2022-04-02",
        noOfTies: 2,
        winnerPrizeMoney: 15000,
        loserPrizeMoney: 5000,
        matchList: null,
        otherText: "This season only a single leg semi final",
      },
      {
        season: "2021-22",
        comp: FACompType.FATrophy,
        roundName: "Final",
        roundDate: "2022-05-22",
        noOfTies: 1,
        winnerPrizeMoney: 60000,
        loserPrizeMoney: 30000,
        matchList: null,
        otherText:
          "The final is played at Wembley Stadium as part of Non League Day",
      },
      {
        season: "2021-22",
        comp: FACompType.FAVase,
        roundName: "Fourth Round Proper",
        roundDate: "2022-01-15",
        noOfTies: 16,
        winnerPrizeMoney: 1875,
        loserPrizeMoney: 625,
        matchList: null,
        otherText: "",
      },
      {
        season: "2021-22",
        comp: FACompType.FAVase,
        roundName: "Fifth Round Proper",
        roundDate: "2022-02-12",
        noOfTies: 8,
        winnerPrizeMoney: 2250,
        loserPrizeMoney: 750,
        matchList: null,
        otherText: "",
      },
      {
        season: "2021-22",
        comp: FACompType.FAVase,
        roundName: "Quarter Final",
        roundDate: "2022-03-12",
        noOfTies: 4,
        winnerPrizeMoney: 4125,
        loserPrizeMoney: 1375,
        matchList: null,
        otherText: "",
      },
      {
        season: "2021-22",
        comp: FACompType.FAVase,
        roundName: "Semi Final",
        roundDate: "2022-04-02",
        noOfTies: 2,
        winnerPrizeMoney: 5475,
        loserPrizeMoney: 1825,
        matchList: null,
        otherText: "This season only a single leg semi final",
      },
      {
        season: "2021-22",
        comp: FACompType.FAVase,
        roundName: "Final",
        roundDate: "2022-05-22",
        noOfTies: 1,
        winnerPrizeMoney: 30000,
        loserPrizeMoney: 15000,
        matchList: null,
        otherText:
          "The final is played at Wembley Stadium as part of Non League Day",
      },
      {
        season: "2021-22",
        comp: FACompType.FACup,
        roundName: "Fourth Round",
        roundDate: "2022-02-02",
        noOfTies: 16,
        winnerPrizeMoney: 90000,
        loserPrizeMoney: null,
        matchList: null,
        otherText: "",
      },
      {
        season: "2021-22",
        comp: FACompType.FACup,
        roundName: "Fifth Round",
        roundDate: "2022-03-02",
        noOfTies: 8,
        winnerPrizeMoney: 150000,
        loserPrizeMoney: null,
        matchList: null,
        otherText: "",
      },
    ],
  },
  {
    season: "2022-23",
    compDetailsList: [
      {
        season: "2022-23",
        comp: FACompType.FATrophy,
        roundName: "First Round Qualifying",
        roundDate: "2022-09-10",
        noOfTies: 16,
        winnerPrizeMoney: 1500,
        loserPrizeMoney: 400,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FATrophy,
        roundName: "Second Round Qualifying",
        roundDate: "2022-09-24",
        noOfTies: 16,
        winnerPrizeMoney: 2250,
        loserPrizeMoney: 575,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FATrophy,
        roundName: "Third Round Qualifying",
        roundDate: "2022-10-08",
        noOfTies: 16,
        winnerPrizeMoney: 2450,
        loserPrizeMoney: 625,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FATrophy,
        roundName: "First Round Proper",
        roundDate: "2022-10-29",
        noOfTies: 128,
        winnerPrizeMoney: 3000,
        loserPrizeMoney: 775,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FATrophy,
        roundName: "Second Round Proper",
        roundDate: "2022-11-19",
        noOfTies: 64,
        winnerPrizeMoney: 3750,
        loserPrizeMoney: 1000,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FATrophy,
        roundName: "Third Round Proper",
        roundDate: "2022-12-17",
        noOfTies: 32,
        winnerPrizeMoney: 4500,
        loserPrizeMoney: 1250,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FATrophy,
        roundName: "Fourth Round Proper",
        roundDate: "2023-01-14",
        noOfTies: 16,
        winnerPrizeMoney: 5250,
        loserPrizeMoney: 1500,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FATrophy,
        roundName: "Fifth Round Proper",
        roundDate: "2023-02-11",
        noOfTies: 8,
        winnerPrizeMoney: 6000,
        loserPrizeMoney: 1750,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FATrophy,
        roundName: "Quarter Final",
        roundDate: "2023-03-11",
        noOfTies: 4,
        winnerPrizeMoney: 7500,
        loserPrizeMoney: 2000,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FATrophy,
        roundName: "Semi Final",
        roundDate: "2023-04-01",
        noOfTies: 2,
        winnerPrizeMoney: 15000,
        loserPrizeMoney: 5000,
        matchList: null,
        otherText: "This season only a single leg semi final",
      },
      {
        season: "2022-23",
        comp: FACompType.FATrophy,
        roundName: "Final",
        roundDate: "2022-03-21",
        noOfTies: 1,
        winnerPrizeMoney: 60000,
        loserPrizeMoney: 30000,
        matchList: null,
        otherText:
          "The final is played at Wembley Stadium as part of Non League Day",
      },
      {
        season: "2022-23",
        comp: FACompType.FAVase,
        roundName: "First Round Qualifying",
        roundDate: "2022-08-27",
        noOfTies: 16,
        winnerPrizeMoney: 550,
        loserPrizeMoney: 160,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FAVase,
        roundName: "Second Round Qualifying",
        roundDate: "2022-09-24",
        noOfTies: 16,
        winnerPrizeMoney: 725,
        loserPrizeMoney: 225,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FAVase,
        roundName: "First Round Proper",
        roundDate: "2022-10-22",
        noOfTies: 16,
        winnerPrizeMoney: 825,
        loserPrizeMoney: 250,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FAVase,
        roundName: "Second Round Proper",
        roundDate: "2022-11-12",
        noOfTies: 16,
        winnerPrizeMoney: 900,
        loserPrizeMoney: 275,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FAVase,
        roundName: "Third Round Proper",
        roundDate: "2022-13-03",
        noOfTies: 32,
        winnerPrizeMoney: 1125,
        loserPrizeMoney: 350,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FAVase,
        roundName: "Fourth Round Proper",
        roundDate: "2023-01-14",
        noOfTies: 16,
        winnerPrizeMoney: 1875,
        loserPrizeMoney: 600,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FAVase,
        roundName: "Fifth Round Proper",
        roundDate: "2023-02-11",
        noOfTies: 8,
        winnerPrizeMoney: 2250,
        loserPrizeMoney: 725,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FAVase,
        roundName: "Quarter Final",
        roundDate: "2023-03-11",
        noOfTies: 4,
        winnerPrizeMoney: 4125,
        loserPrizeMoney: 1350,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FAVase,
        roundName: "Semi Final",
        roundDate: "2023-04-01",
        noOfTies: 2,
        winnerPrizeMoney: 5500,
        loserPrizeMoney: 1725,
        matchList: null,
        otherText: "This season only a single leg semi final",
      },
      {
        season: "2022-23",
        comp: FACompType.FAVase,
        roundName: "Final",
        roundDate: "2023-05-21",
        noOfTies: 1,
        winnerPrizeMoney: 30000,
        loserPrizeMoney: 15000,
        matchList: null,
        otherText:
          "The final is played at Wembley Stadium as part of Non League Day",
      },
      {
        season: "2022-23",
        comp: FACompType.FACup,
        roundName: "Extra Preliminary Round",
        roundDate: "2022-08-06",
        noOfTies: 208,
        winnerPrizeMoney: 1125,
        loserPrizeMoney: 375,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FACup,
        roundName: "Preliminary Round",
        roundDate: "2022-08-20",
        noOfTies: 136,
        winnerPrizeMoney: 1444,
        loserPrizeMoney: 481,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FACup,
        roundName: "First Round Qualifying",
        roundDate: "2022-09-03",
        noOfTies: 112,
        winnerPrizeMoney: 2250,
        loserPrizeMoney: 750,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FACup,
        roundName: "Second Round Qualifying",
        roundDate: "2022-09-17",
        noOfTies: 80,
        winnerPrizeMoney: 3375,
        loserPrizeMoney: 1125,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FACup,
        roundName: "Third Round Qualifying",
        roundDate: "2022-10-01",
        noOfTies: 40,
        winnerPrizeMoney: 5625,
        loserPrizeMoney: 1875,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FACup,
        roundName: "Fourth Round Qualifying",
        roundDate: "2022-10-15",
        noOfTies: 32,
        winnerPrizeMoney: 9375,
        loserPrizeMoney: 3125,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FACup,
        roundName: "First Round Proper",
        roundDate: "2022-11-05",
        noOfTies: 40,
        winnerPrizeMoney: 36000,
        loserPrizeMoney: null,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FACup,
        roundName: "Second Round Proper",
        roundDate: "2022-11-26",
        noOfTies: 20,
        winnerPrizeMoney: 60000,
        loserPrizeMoney: null,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FACup,
        roundName: "Third Round Proper",
        roundDate: "2023-01-07",
        noOfTies: 32,
        winnerPrizeMoney: 100000,
        loserPrizeMoney: null,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FACup,
        roundName: "Fourth Round",
        roundDate: "2023-01-28",
        noOfTies: 16,
        winnerPrizeMoney: 120000,
        loserPrizeMoney: null,
        matchList: null,
        otherText: "",
      },
      {
        season: "2022-23",
        comp: FACompType.FACup,
        roundName: "Fifth Round",
        roundDate: "2023-03-01",
        noOfTies: 8,
        winnerPrizeMoney: 225000,
        loserPrizeMoney: null,
        matchList: null,
        otherText: "",
      },
    ],
  },
];
